import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const SupportMenu = () => {
    const location = useLocation();

    const isNotice =
        location.pathname === '/support' ||
        location.pathname.startsWith('/support/notice');

    const isFaq =
        location.pathname.startsWith('/support/faq');

    const isInquiry =
        location.pathname.startsWith('/inquiry');

    return (
        <section className="support-menu-section">
            <div className="support-menu-inner">
                <Link
                    to="/support"
                    className={`support-menu-item ${
                        isNotice ? 'active' : ''
                    }`}
                >
                    <i className="mdi mdi-message-text-outline"></i>

                    <span>
                        공지사항
                    </span>
                </Link>

                <Link
                    to="/support/faq"
                    className={`support-menu-item ${
                        isFaq ? 'active' : ''
                    }`}
                >
                    <i className="mdi mdi-file-question-outline"></i>

                    <span>
                        자주 묻는 질문
                    </span>
                </Link>

                <Link
                    to="/inquiry"
                    className={`support-menu-item ${
                        isInquiry ? 'active' : ''
                    }`}
                >
                    <i className="mdi mdi-file-document-edit-outline"></i>

                    <span>
                        견적문의
                    </span>
                </Link>
            </div>
        </section>
    );
};

export default SupportMenu;